export default function Button(props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
    return <button className="px-2 py-1 bg-gray-300 text-gray-700 rounded-sm" {...props} />
}